import PropTypes from 'prop-types';
import { useUserDeletedStatus, useUserName } from '../../../slice';
import { getLocalUserDetails } from '../../utils';

function UserProfileName({ userId, className }) {
    const localUserDetails = getLocalUserDetails();
    const userName = useUserName(userId);
    const userDeletedStatus = useUserDeletedStatus(userId);

    // Handle undefined userId
    if (!userId) return <span className={className}>Unknown</span>;
    if (userDeletedStatus) return <span className={className}>Deleted User</span>;
    if (localUserDetails.userId === userId) return <span className={className}>You</span>;
    return <span className={className}>{userName}</span>;
}

UserProfileName.propTypes = {
    userId: PropTypes.string, // Made optional to handle undefined gracefully
    className: PropTypes.string,
};

export default UserProfileName;
